export class BirthdayModelInputDTO {
    id: number;
    roomId: number;
    city: string;
    BirthdayZoneId: number;
    VisitorId: number;
    EmployeeId: number;
    Discount: number;
    advancePaymentWill: number;
    advancePaymentWillString: string;
    AdvancePayment: number;
    FinalPlannedPrice: number;
    CallDate: Date;
    AppointmentDate: Date;
    PricePerChildren: number
    PlannedChildNumber: number
    PresentChildNumber: number
    TotalPricePaid: number;
    TotalPricePaidWithoutDicount: number;
    CallStatus: number
    startTimeBirthday: string;
    BirthdayStart: string;
    BirthDayEnds: string
    EmployName: string
    SavedTimeSlotId: number
    TotalPricePaidWithAdds: number;
    TotalPricePaidAdds: number;
    isFlexible: boolean
    endTimeBirthday: string
    SavedTimeEndSlotId: number
    // birthdayStart: string;
    AddsTotalNamePrices: { name: string; quantity: string; price: number; }[];
    CommentBirthdayAppointment?: string;
    BirthDayEndsDt: Date
    NumberOfBirthday: number
    roomName: string;
    constructor() {
        this.roomId = null;
        this.BirthdayZoneId = null;
        this.VisitorId = null;
        this.EmployeeId = null;
        this.Discount = 0;
        this.advancePaymentWill = 0;
        this.advancePaymentWillString = "";
        this.city = "";
        this.EmployName = "";
        this.AdvancePayment = 0;
        this.FinalPlannedPrice = null
        this.CallDate = null;
        this.AppointmentDate = null;
        this.PricePerChildren = null
        this.PlannedChildNumber = null
        this.PresentChildNumber = null
        this.TotalPricePaid = null;
        this.TotalPricePaidWithoutDicount = null;
        this.CallStatus = null
        this.BirthDayEnds = '';
        this.startTimeBirthday = ''
        this.SavedTimeSlotId = null;
        this.AddsTotalNamePrices = []
        //this.birthdayStart = '';
        this.CommentBirthdayAppointment = '';
        this.isFlexible = false
        this.endTimeBirthday = ''
        this.SavedTimeSlotId = null
        this.SavedTimeEndSlotId = null;
        this.BirthDayEndsDt = null;
        this.NumberOfBirthday = null;
        this.roomName = "";
    }
}